// removed by extract-text-webpack-plugin
module.exports = {"root":"Logo__root--HMg9n","compressed":"Logo__compressed--1HrUV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Library/Logo/Logo.css
// module id = ./src/components/Library/Logo/Logo.css
// module chunks = 4